import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import 'animate.css';
import api from '../api.js';
import { showToast } from '../Components/PopupMessage.jsx';

const ContactUs = () => {
  const navigate = useNavigate();
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [comment, setComment] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault(); // prevent form default reload

    try {
      const response = await api.post('/user_api/contact/post-message', {
        first_name: firstname,
        last_name: lastname,
        email: email,
        number: number,
        message: comment,
      });

      console.log('Response:', response.data);

      if (response.data.status === 'success') {
        showToast('Message sent successfully', 'success');
        setFirstname('');
        setLastname('');
        setEmail('');
        setNumber('');
        setComment('');
      } else {
        showToast('Something went wrong. Please try again.', 'error');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      showToast('Failed to send message. Please try again.', 'error');
    }
  };

  return (
    <section className="ec-page-content py-5 bg-white">
      <div className="container">
        <div className="row g-5 ec-common-wrapper">
          {/* Contact Form */}
          <div className="col-lg-6 animate__animated animate__fadeInLeft">
            <div className="bg-light p-4 rounded shadow-sm">
              <h3 className="text-primary mb-4">Send Us a Message</h3>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">First Name*</label>
                  <input
                    type="text"
                    className="form-control"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                    placeholder="Enter your first name"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Last Name*</label>
                  <input
                    type="text"
                    className="form-control"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                    placeholder="Enter your last name"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email*</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Number*</label>
                  <input
                    type="number"
                    className="form-control"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                    placeholder="Enter your phone number"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Comments/Questions*</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Please leave your comments here..."
                    required
                  ></textarea>
                </div>
                <div className="d-grid">
                  <button className="btn btn-primary btn-lg" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Map and Contact Info */}
          <div className="col-lg-6 animate__animated animate__fadeInRight">
            <div className="bg-white p-4 rounded shadow-sm h-100">
              <div className="mb-4">
                <iframe
                  title="Google Map"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14432.971512773956!2d55.2926851!3d25.2624139!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x4f5812feebb9437b!2sCITY%20CHOICE%20GENERAL%20TRADING%20LLC!5e0!3m2!1sen!2sin!4v1636291392808!5m2!1sen!2sin"
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
              <div>
                <h3 className="text-primary mb-3">Contact Info</h3>
                <ul className="list-unstyled text-secondary">
                  <li className="mb-2">
                    <i className="bi bi-geo-alt-fill me-2 text-danger"></i>
                    <strong>Address:</strong> Emirates ID: 113729 Near Astoria Hotel
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-telephone-fill me-2 text-success"></i>
                    <strong>Call Us:</strong>{' '}
                    <a href="tel:+97143530070" className="text-decoration-none text-dark">
                      +971 4 353 0070
                    </a>
                  </li>
                  <li>
                    <i className="bi bi-envelope-fill me-2 text-warning"></i>
                    <strong>Email:</strong>{' '}
                    <a href="mailto:info@citychoicedxb.com" className="text-decoration-none text-dark">
                      info@citychoicedxb.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
